module.exports = __webpack_public_path__ + "static/media/filterMobile.998937ea.svg";